import React from 'react';
import { axiosinstance, axiosCatch } from '../../components/axios';
import ConfidentialServersList from './productList';
import PlanPreLoader from '../../components/planPreloader';
import LoadingError from '../../components/loadingError';
import lscache from 'lscache';
import ReactSlider from 'react-slider';
import { withRouter } from 'react-router-dom';

class DynamicContent extends React.Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            products: [],
            error: false,
            loading: true,
            discount: false,
            backup: false,
            payment_period: 1,
            configCount: 0
        }
    }

    handleJsonLdGenerated = (JSON) => {
        this.props.onJsonLdGenerated(JSON)
    }

    componentDidMount() {
        this.load();
    }

    load = () => {
        this.setState({
            loading: true
        }, () => {
            if (lscache.get('confidentialServersProducts') === null) {
                axiosinstance({
                    method: 'get',
                    url: "https://api.swissmade.host/jsapi/v1/products/hyperserver.en.json"
                })
                    .then((response) => {
                        if (response.status === 200) {
                            if (response.data.result === true) {
                                lscache.set('confidentialServersProducts', response, 10);
                                this.setState({
                                    products: response.data.data.products,
                                    addons: response.data.data.addons,
                                    os_templates: response.data.data.os_templates,
                                    price_from_initial: Math.min(...response.data.data.products.map(i => i.price)),
                                    price_to_initial: Math.max(...response.data.data.products.map(i => i.price)),
                                    price_from: Math.min(...response.data.data.products.map(i => i.price)),
                                    price_to: Math.max(...response.data.data.products.map(i => i.price)),
                                    storage_from_initial: Math.min(...response.data.data.products.map(o => o.config.storage)),
                                    storage_to_initial: Math.max(...response.data.data.products.map(o => o.config.storage)),
                                    storage_from: Math.min(...response.data.data.products.map(o => o.config.storage)),
                                    storage_to: Math.max(...response.data.data.products.map(o => o.config.storage)),
                                    ram_from_initial: Math.min(...response.data.data.products.map(o => o.config.ram)),
                                    ram_to_initial: Math.max(...response.data.data.products.map(o => o.config.ram)),
                                    ram_from: Math.min(...response.data.data.products.map(o => o.config.ram)),
                                    ram_to: Math.max(...response.data.data.products.map(o => o.config.ram)),
                                    configCount: response.data.data.products.length,
                                    loading: false
                                });
                            } else {
                                this.setState({
                                    error: true,
                                    loading: false
                                });
                            }
                        } else {
                            this.setState({
                                error: true,
                                loading: false
                            });
                        }
                    }).catch((args) => {
                        axiosCatch(args, this.props);
                    });
            } else {
                this.setState({
                    products: lscache.get('confidentialServersProducts').data.data.products,
                    addons: lscache.get('confidentialServersProducts').data.data.addons,
                    os_templates: lscache.get('confidentialServersProducts').data.data.os_templates,
                    price_from_initial: Math.min(...lscache.get('confidentialServersProducts').data.data.products.map(i => i.price)),
                    price_to_initial: Math.max(...lscache.get('confidentialServersProducts').data.data.products.map(i => i.price)),
                    price_from: Math.min(...lscache.get('confidentialServersProducts').data.data.products.map(i => i.price)),
                    price_to: Math.max(...lscache.get('confidentialServersProducts').data.data.products.map(i => i.price)),
                    storage_from_initial: Math.min(...lscache.get('confidentialServersProducts').data.data.products.map(o => o.config.storage)),
                    storage_to_initial: Math.max(...lscache.get('confidentialServersProducts').data.data.products.map(o => o.config.storage)),
                    storage_from: Math.min(...lscache.get('confidentialServersProducts').data.data.products.map(o => o.config.storage)),
                    storage_to: Math.max(...lscache.get('confidentialServersProducts').data.data.products.map(o => o.config.storage)),
                    ram_from_initial: Math.min(...lscache.get('confidentialServersProducts').data.data.products.map(o => o.config.ram)),
                    ram_to_initial: Math.max(...lscache.get('confidentialServersProducts').data.data.products.map(o => o.config.ram)),
                    ram_from: Math.min(...lscache.get('confidentialServersProducts').data.data.products.map(o => o.config.ram)),
                    ram_to: Math.max(...lscache.get('confidentialServersProducts').data.data.products.map(o => o.config.ram)),
                    configCount: lscache.get('confidentialServersProducts').data.data.products.length,
                    loading: false
                });
            }

            if (lscache.get('exchangeRates') === null) {
                axiosinstance.get(process.env.REACT_APP_BACKEND_URL + "/variables.json")
                    .then(res => {
                        if (res.status === 200 && res.data.result === true) {
                            this.setState({
                                usd: res.data.data.currencies.find(x => x.short_name === 'USD').rate,
                                eur: res.data.data.currencies.find(x => x.short_name === 'EUR').rate,
                                btc: res.data.data.currencies.find(x => x.short_name === 'BTC').rate
                            })
                            lscache.set('exchangeRates', res, 3);
                        } else {
                            this.setState({
                                error: true
                            });
                        }
                    })
            } else {
                this.setState({
                    usd: lscache.get('exchangeRates').data.data.currencies.find(x => x.short_name === 'USD').rate,
                    eur: lscache.get('exchangeRates').data.data.currencies.find(x => x.short_name === 'EUR').rate,
                    btc: lscache.get('exchangeRates').data.data.currencies.find(x => x.short_name === 'BTC').rate
                })
            }
        });
    }

    countConfigs = (count) => {
        this.setState({
            configCount: count
        })
    }

    discountFilter = () => {
        this.setState({
            discount: !this.state.discount
        })
    }

    backupFilter = () => {
        this.setState({
            backup: !this.state.backup
        })
    }

    resetFilters = () => {
        this.setState({
            price_from: this.state.price_from_initial,
            price_to: this.state.price_to_initial,
            storage_from: this.state.storage_from_initial,
            storage_to: this.state.storage_to_initial,
            ram_from: this.state.ram_from_initial,
            ram_to: this.state.ram_to_initial,
            monthsSliderValue: 1,
            payment_period: 1,
            discount: false,
            backup: false
        });
        setTimeout(
            () => {
                this.setState({
                    priceSliderValue: undefined,
                    monthsSliderValue: undefined,
                    ramSliderValue: undefined,
                    storageSliderValue: undefined
                })
            }, 1)
    }

    render() {
        if (this.state.loading) {
            return (
                <PlanPreLoader />
            )
        }
        if (this.state.error) {
            return (
                <LoadingError />
            )
        } else {
            return (
                <React.Fragment>
                    <div className="fullwidth">
                        <div className="row">
                            <div className="twelve columns">
                                {!this.props.id 
                                ? <fieldset className="filter-container-dedicated">
                                    <legend><strong>{this.state.configCount}</strong> Server{this.state.configCount !== 1 && 's'} found <button onClick={this.resetFilters}><i className="fa-solid fa-rotate-left"></i> reset</button></legend>
                                    <div className="row">
                                        <div className="four columns">
                                            <div className='slider-legend slider-price'><span className='title'>Price: </span><span className='value'>from {new Intl.NumberFormat('de-CH', { style: 'currency', currency: 'CHF' }).format(this.state.price_from)} </span><span className='value'> to {new Intl.NumberFormat('de-CH', { style: 'currency', currency: 'CHF' }).format(this.state.price_to)}</span></div>
                                            <ReactSlider
                                                className="horizontal-slider"
                                                thumbClassName="slider-thumb"
                                                trackClassName="slider-track-range"
                                                renderThumb={(props, state) => <div {...props}>{state.valueNow.toLocaleString('de-CH')}</div>}
                                                defaultValue={[this.state.price_from_initial, this.state.price_to_initial]}
                                                min={this.state.price_from_initial}
                                                max={this.state.price_to_initial}
                                                ariaLabel={['Price from', 'Price to']}
                                                ariaValuetext={state => `Price value ${state.valueNow} CHF`}
                                                step={5}
                                                pearling
                                                minDistance={5}
                                                value={this.state.priceSliderValue}
                                                onChange={([thumb1, thumb2]) => {
                                                    this.setState({
                                                        price_from: thumb1,
                                                        price_to: thumb2
                                                    })
                                                }}
                                            />
                                        </div>
                                        <div className="four columns">
                                            <div className='slider-legend slider-price'><span className='title'>Storage: </span><span className='value'>from {this.state.storage_from.toLocaleString('de-CH')} GB </span><span className='value'> to {this.state.storage_to.toLocaleString('de-CH')} GB</span></div>
                                            <ReactSlider
                                                className="horizontal-slider"
                                                thumbClassName="slider-thumb"
                                                trackClassName="slider-track-range"
                                                defaultValue={[this.state.storage_from_initial, this.state.storage_to_initial]}
                                                min={this.state.storage_from_initial}
                                                max={this.state.storage_to_initial}
                                                ariaLabel={['Storage from', 'Storage to']}
                                                ariaValuetext={state => `Storage value ${state.valueNow} GB`}
                                                renderThumb={(props, state) => <div {...props}>{state.valueNow.toLocaleString('de-CH')}</div>}
                                                value={this.state.storageSliderValue}
                                                step={10}
                                                pearling
                                                minDistance={10}
                                                onChange={([thumb1, thumb2]) => {
                                                    this.setState({
                                                        storage_from: thumb1,
                                                        storage_to: thumb2
                                                    })
                                                }}
                                            />
                                        </div>
                                        <div className="four columns">
                                            <div className='slider-legend slider-price'><span className='title'>RAM: </span><span className='value'>from {Math.round(this.state.ram_from / 1024)} GB </span><span className='value'> to {Math.round(this.state.ram_to / 1024)} GB</span></div>
                                            <ReactSlider
                                                className="horizontal-slider"
                                                thumbClassName="slider-thumb"
                                                trackClassName="slider-track-range"
                                                defaultValue={[this.state.ram_from_initial, this.state.ram_to_initial]}
                                                min={this.state.ram_from_initial}
                                                max={this.state.ram_to_initial}
                                                ariaLabel={['RAM from', 'RAM to']}
                                                ariaValuetext={state => `RAM value ${Math.round(state.valueNow / 1024)} GB`}
                                                renderThumb={(props, state) => <div {...props}>{Math.round(state.valueNow / 1024)}</div>}
                                                value={this.state.ramSliderValue}
                                                step={1024}
                                                pearling
                                                minDistance={1024}
                                                onChange={([thumb1, thumb2]) => {
                                                    this.setState({
                                                        ram_from: thumb1,
                                                        ram_to: thumb2
                                                    })
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="row margin-top">
                                        <div className="four columns">
                                            <div className='slider-legend slider-price'><span className='title'>Billing cycle: </span><span className='value'>{this.state.payment_period} month(s)</span> <span className='title'>Discount:</span> <span className='value'>{(this.state.payment_period - 1) * 2}%</span></div>
                                            <ReactSlider
                                                className="horizontal-slider"
                                                thumbClassName="slider-thumb"
                                                trackClassName="slider-track"
                                                defaultValue={1}
                                                step={1}
                                                renderThumb={(props, state) => <div {...props}>{state.valueNow}</div>}
                                                min={1}
                                                max={12}
                                                value={this.state.monthsSliderValue}
                                                onChange={(value) => {
                                                    this.setState({
                                                        payment_period: value
                                                    })
                                                }}
                                            />
                                        </div>
                                        <div className="four columns">
                                            <div className='row'>
                                                <div className="column-33 config-options">
                                                    <div className='slider-legend slider-price'><span className='title'>Other options: </span></div>
                                                    <input type="checkbox" className='css-checkbox' name="backup" id="backup" checked={this.state.backup} onChange={this.backupFilter} />
                                                    <label htmlFor="backup">Free backup</label>
                                                    <input type="checkbox" className='css-checkbox' name="discount" id="discount" checked={this.state.discount} onChange={this.discountFilter} />
                                                    <label htmlFor="discount" className='special'>Special offer</label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </fieldset>
                                : <div className="row discount-slider-single productPreview">
                                    <div className="eight columns">
                                            <ReactSlider
                                                className="horizontal-slider-single-block"
                                                thumbClassName="slider-thumb"
                                                trackClassName="slider-track"
                                                defaultValue={this.state.payment_period}
                                                step={1}
                                                marks={[1,2,3,4,5,6,7,8,9,10,11,12]}
                                                renderThumb={(props, state) => <div {...props}>{(state.valueNow -1) * 2} %</div>}
                                                renderMark={(props) => <span {...props}>{props.key} m.</span>}
                                                min={1}
                                                max={12}
                                                onChange = {(value) => {
                                                    this.setState({
                                                        payment_period: value
                                                    })
                                                }}
                                            />
                                    </div>
                                    <div className="four columns">
                                        <p className='discountText'>The longer the billing period, the higher your discount will be. Move the slider thumb to see how much you can save on the longer-term confidential server deal.</p>
                                    </div>
                                </div>
                                }
                                <div className="config-container-sorting">
                                    <ConfidentialServersList
                                        usdRate={this.state.usd}
                                        eurRate={this.state.eur}
                                        btcRate={this.state.btc}
                                        list={this.state.products}
                                        payment_period={this.state.payment_period}
                                        sliderPriceFrom={this.state.price_from}
                                        sliderPriceTo={this.state.price_to}
                                        sliderRamFrom={this.state.ram_from}
                                        sliderRamTo={this.state.ram_to}
                                        sliderStorageFrom={this.state.storage_from}
                                        sliderStorageTo={this.state.storage_to}
                                        discount={this.state.discount}
                                        backup={this.state.backup}
                                        countConfigs={this.countConfigs}
                                        onJsonLdGenerated={this.handleJsonLdGenerated}
                                        os_templates={this.state.os_templates}
                                        id={this.props.id}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </React.Fragment>
            )
        }
    }
}

export default withRouter(DynamicContent);
